import React from "react"
import styled from "@emotion/styled"
import { navigate } from "gatsby"

const BackwardButton = styled.button`
  border-width: 0px;
  background-color: transparent;
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 21px;
  padding: 0;
  text-transform: uppercase;
  line-height: 1.3rem;
  cursor: pointer;
  color: ${props => props.theme.colors.heading};
  &:focus {
    outline: none;
  }
  &:before {
    content: "\u2190";
    position: relative;
    top: -2px;
  }
`
const goBack = () => {
  navigate(-1)
}

export default function Home() {
  return (
      <BackwardButton onClick={goBack}> Назад</BackwardButton>
  )
}
